import Joi from "joi-browser";
import { useState } from "react";

export function useFormFields(initialState) {
  const [fields, setValues] = useState(initialState);

  return [
    fields,
    function (event) {
      setValues({
        ...fields,
        [event.target.id]: event.target.type && event.target.type === "checkbox" ?
          event.target.checked : event.target.value,
      });
    },
  ];
}

export function validateForms(obj, schema, paramTypes) {

  const valid = Joi.validate(obj, schema, {
    abortEarly: false,
  });
  const newErrorObject = {};
  if (valid.error) {
    valid.error.details.forEach((err) => {
      if ((err.path[0] in paramTypes && paramTypes[err.path[0]].required) || ([err.path[0]] in obj && obj[err.path[0]].length > 0)) {
        switch (err.type) {
          case "any.empty":
          case "any.required":
            err.message = `${
              paramTypes[err.path[0]].fieldName
              } should not be empty!`;
            break;
          case "string.min":
            err.message = `${
              paramTypes[err.path[0]].fieldName
              } should have at least ${err.context.limit} characters!`;
            break;
          case "string.max":
            err.message = `${
              paramTypes[err.path[0]].fieldName
              } should have at most ${err.context.limit} characters!`;
            break;
          case "string.regex.base":
            err.message = `Invalid ${paramTypes[err.path[0]].fieldName}`;
            break;
          case "any.allowOnly":
            err.message = `${paramTypes[err.path[0]].fieldName} do not match`;
            break;
          case "number.base":
            err.message = `${paramTypes[err.path[0]].fieldName} should be a number`;
            break;
          case "number.min":
            err.message = `${paramTypes[err.path[0]].fieldName} should be more than or equal to ${err.context.limit}`;
            break;
          case "number.max":
            err.message = `${paramTypes[err.path[0]].fieldName} should be less than or equal to ${err.context.limit}`;
            break;
          case "number.ref":
            err.message = `${paramTypes[err.path[0]].fieldName} refers to ${paramTypes[err.context.ref].fieldName} `;
            break;
          case "string.email":
            err.message = `${paramTypes[err.path[0]].fieldName} should be a valid email`;
            break;
          default:
            break;
        }
        newErrorObject[err.path.join(".")] = err.message;
      }
    });
  }
  return newErrorObject;
}